// Mappings shared by every profile: Word's built-in style names → semantic HTML5.
import { para, run, rule, quietPara, quietRun } from "./rules.js";

export const CALLOUTS = ["Note", "Tip", "Important", "Warning", "Caution"];

// Copied from mammoth's defaults and stated explicitly so they come before quiet "List Paragraph".
const LIST_RULES = [1, 2, 3, 4, 5].flatMap((level) => {
  const parents = "ul|ol > li > ".repeat(level - 1);
  return [
    rule({ match: `ul${level}`, html: `${parents}ul > li:fresh`, sample: "list" }),
    rule({ match: `ol${level}`, html: `${parents}ol > li:fresh`, sample: "list" }),
  ];
});

export const QUIET_PARAGRAPHS = [
  "Normal", "Body Text", "Body Text 2", "Body Text 3", "Body Text Indent", "Body Text First Indent",
  "No Spacing", "Normal (Web)", "Plain Text", "List Paragraph",
  ...[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => `TOC ${n}`), "TOC Heading",
  "Footnote Text", "Endnote Text", "Date", "Salutation", "Closing", "Signature",
];

export const QUIET_RUNS = [
  "Default Paragraph Font", "Hyperlink", "FollowedHyperlink", "Placeholder Text", "Page Number",
  "Footnote Reference", "Endnote Reference", "Comment Reference",
  "Subtle Emphasis", "Subtle Reference", "Intense Reference",
  ...[1, 2, 3, 4, 5, 6].map((n) => `Heading ${n} Char`),
  "Title Char", "Subtitle Char", "Quote Char", "Intense Quote Char", "Body Text Char", "Plain Text Char",
  "HTML Preformatted Char",
];

export const baseRules = [
  para("Title", "hgroup > h1:fresh", "title"),
  para("Subtitle", "hgroup > p:fresh", "title"),
  ...[1, 2, 3, 4, 5, 6].map((n) => para(`Heading ${n}`, `h${n}:fresh`, "heading")),
  para("Lead", "p.lead:fresh", "paragraph"),
  para("HTML Address", "address > p:fresh", "paragraph"),
  para("Quote", "blockquote > p:fresh", "quote"),
  para("Quote Attribution", "blockquote > footer:fresh", "quote"),
  para("Intense Quote", "blockquote.intense > p:fresh", "quote"),
  ...CALLOUTS.map((name) => para(name, `aside.${name.toLowerCase()} > p:fresh`, "callout")),
  para("HTML Preformatted", "pre:separator('\\n')", "code"),
  para("Code Block", "pre:separator('\\n')", "code"),
  para("Caption", "p.caption:fresh", "caption"),
  run("Strong", "strong"),
  run("Emphasis", "em"),
  run("Intense Emphasis", "strong > em"),
  run("Book Title", "cite"),
  run("HTML Cite", "cite"),
  run("HTML Code", "code"),
  run("HTML Keyboard", "kbd"),
  run("HTML Variable", "var"),
  run("HTML Sample", "samp"),
  run("HTML Definition", "dfn"),
  run("HTML Acronym", "abbr"),
  run("Badge", "span.badge"),
  rule({ match: "highlight", html: "mark", sample: "inline" }),
  ...LIST_RULES,
  rule({ match: "table", style: "Grid Table", prefix: true, html: "table", sample: "table" }),
  rule({ match: "table", style: "List Table", prefix: true, html: "table", sample: "table" }),
  rule({ match: "table", html: "table", sample: "table" }),
  ...QUIET_PARAGRAPHS.map(quietPara),
  ...QUIET_RUNS.map(quietRun),
];
